export enum BoughtTogetherFallbackMethod {
  MostAddedToCart = 'most_added_to_cart',
  CustomFallback = 'custom_fallback',
  None = 'none',
}
